export default __webpack_public_path__ + "static/media/kinesso.88410c1f.svg";